import { useNavigate, useParams } from "react-router-dom";
import { useEffect } from "react";

const ProductDetails = () => {
  const navigate = useNavigate();
  const { product_id, product_name } = useParams();

  useEffect(() => {
    navigate(`/ProductDetails/${product_id}/${product_name}`);
  }, [navigate, product_id, product_name]);

  return <></>;
};

export default ProductDetails;
